var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"options":_vm.items,"hasNextPage":_vm.hasNextPage,"fetchNextPage":_vm.fetchNextPage,"isLoading":_vm.isLoading,"initialFetch":_vm.initialFetch})],2)}
var staticRenderFns = []

export { render, staticRenderFns }